export default "__VITE_ASSET__BNDUp5Nz__"